export const ThemeStyle = {
  MODERN: 'modern',
  STANDARD: 'standard',
};
export const ThemeStyleRadius = {
  MODERN: 30,
  STANDARD: 16,
};
export const ThemeMode = {
  LIGHT: 'light',
  DARK: 'dark',
};
export const LayoutType = {
  FULL_WIDTH: 'full-width',
  BOXED: 'boxed',
  FRAMED: 'framed',
};
export const MenuStyle = {
  DEFAULT: 'default',
  STANDARD: 'standard',
  ROUNDED: 'rounded',
  ROUNDED_REVERSE: 'rounded-reverse',
  CURVED_MENU: 'curved-menu',
};
export const LayoutDirection = {
  RTL: 'rtl',
  LTR: 'ltr',
};
export const NavStyle = {
  DEFAULT: 'default',
  BIT_BUCKET: 'bit_bucket',
  STANDARD: 'standard',
  DRAWER: 'drawer',
  MINI: 'mini',
  MINI_SIDEBAR_TOGGLE: 'mini-sidebar-onToggleSidebar',
  HEADER_USER: 'user-header',
  HEADER_USER_MINI: 'user-mini-header',
  H_DEFAULT: 'h-default',
  HOR_HEADER_FIXED: 'hor-header-fixed',
  HOR_DARK_LAYOUT: 'hor-dark-layout',
};
export const FooterType = {
  FIXED: 'fixed',
  FLUID: 'fluid',
};
export const HeaderType = {
  FLUID: 'fluid',
  FIXED: 'fixed',
};
export const RouteTransition = {
  NONE: 'none',
  alpha: 'alpha',
  SLIDE_LEFT: 'slideLeft',
  SLIDE_RIGHT: 'slideRight',
  SLIDE_UP: 'slideUp',
  SLIDE_DOWN: 'slideDown',
};
export const Fonts = {
  LIGHT: '300',
  REGULAR: '400',
  MEDIUM: '500',
  SEMI_BOLD: '600',
  BOLD: '700',
};

export const AuthType = {
  FIREBASE: 'firebase',
  AWS_COGNITO: 'aws_cognito',
  AUTH0: 'auth0',
  JWT_AUTH: 'jwt_auth',
};

export const stringToColor = (string) => {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

export const stringAvatar = (name, width = null, height = null) => {
  if (name) {
    const nameParts = name.split(' ');
    const firstInitial = nameParts[0]?.[0] || '';
    const secondInitial = nameParts[1]?.[0] || '';

    return {
      sx: {
        bgcolor: stringToColor(name),
        width: width ?? 48,
        height: height ?? 48,
        cursor: 'pointer',
      },
      children: `${firstInitial}${secondInitial}`,
    };
  } else {
    return {
      sx: {
        bgcolor: (theme) => theme.palette.primary.main,
        width: width ?? 48,
        height: height ?? 48,
      },
    };
  }
};

export const AppsURL = {
  '1': process.env.REACT_APP_CRSFE || 'https://crsfe3.kubekkp.coofis.com/oidc/authenticate/',
  '2': process.env.REACT_APP_EMAIL || 'https://mailkkp.coofis.com/mail/?_task=login&_action=oauth',
  '3': process.env.REACT_APP_CALENDAR || '',
  '4': process.env.REACT_APP_KEBIJAKAN || 'https://policy.kubekkp.coofis.com/oidc/authenticate/',
  '6': process.env.REACT_APP_MP || 'https://mp.kubekkp.coofis.com/',
  '7': process.env.REACT_APP_ADMINMP || '',
  '8': process.env.REACT_APP_CUTI || 'https://cuti.kubekkp.coofis.com/',
  '9': process.env.REACT_APP_VIDEO || 'https://conference.kubekkp.coofis.com/',
  '10': process.env.REACT_APP_SPPD || 'https://monperdin.kubekkp.coofis.com/oidc/authenticate/',
  '11': process.env.REACT_APP_CHAT || 'https://chat.coofis.com/?redirect_url=/apps/spreed/&redirect_key=',
  '12': process.env.REACT_APP_HELPDESK || 'https://helpdesk.kubekkp.coofis.com/oidc/authenticate/',
  '13': process.env.REACT_APP_REPOSITORY || 'https://chat.coofis.com/?redirect_url=/apps/files/&redirect_key=',
  '14': process.env.REACT_APP_BSRE_VALIDATE || 'https://tte.komdigi.go.id/verifyPDF',
  '15': process.env.REACT_APP_ELEARNING || 'https://emilea.kkp.go.id',
  '16': process.env.REACT_APP_ARSIP || 'https://crsfe3.kubekkp.coofis.com/oidc/authenticate/?next=aHR0cHM6Ly9jcnNmZTMua3ViZWtrcC5jb29maXMuY29tL2Fyc2lwLzpPbXVwTkNYM2hfU3BTVjBVWVBqb3hnUmhxN0JibkFGRzRYcmlEUnUtRk0w',
  '17': process.env.REACT_APP_SIPEG || 'https://sipeg.kubekkp.coofis.com'
};

export const AutHSSO = process.env.REACT_APP_AuthSSO || 'https://auth.kubekkp.coofis.com/oidc/extoken'

export const requestOptionsGET = (propsToken = undefined) => {
  let token;
  if (propsToken) token = propsToken;
  else token = sessionStorage.getItem('token');
  return {
    method: 'GET',
    headers: {
      Authorization: `${token}`,
    },
  };
};

export const requestOptionsGETwithData = (propsToken = undefined) => {
  let token;
  if (propsToken) token = propsToken;
  else token = sessionStorage.getItem('token');
  return {
    method: 'GET',
    headers: {
      Authorization: `${token}`,
    },
    responseType: 'blob',
  };
};

export const requestOptionsPATCH = (propsToken = undefined) => {
  let token;
  if (propsToken) token = propsToken;
  else token = sessionStorage.getItem('token');
  return {
    method: 'PATCH',
    headers: {
      Authorization: `${token}`,
    },
  };
};

export const requestOptionsPUT = (propsToken = undefined) => {
  let token;
  if (propsToken) token = propsToken;
  else token = sessionStorage.getItem('token');
  return {
    method: 'PUT',
    headers: {
      "Content-Type": "application/json",
      Authorization: `${token}`,
    },
  };
};

export const requestOptionsPOST = (propsToken = undefined) => {
  let token;
  if (propsToken) token = propsToken;
  else token = sessionStorage.getItem('token');
  return {
    method: 'POST',
    headers: {
      Authorization: `${token}`,
    },
  };
};

export const requestOptionsPOSTwithData = (propsToken = undefined) => {
  let token;
  if (propsToken) token = propsToken;
  else token = sessionStorage.getItem('token');
  return {
    method: 'POST',
    headers: {
      Authorization: `${token}`,
      'content-type': 'multipart/form-data',
    },
  };
};

export const requestOptionsDELETE = (propsToken = undefined) => {
  let token;
  if (propsToken) token = propsToken;
  else token = sessionStorage.getItem('token');
  return {
    method: 'DELETE',
    headers: {
      Authorization: `${token}`,
    },
  };
};

export const requestOptionsDELETEwithDATA = (data, propsToken = undefined) => {
  let token;
  if (propsToken) token = propsToken;
  else token = sessionStorage.getItem('token');
  return {
    method: 'DELETE',
    headers: {
      Authorization: `${token}`,
    },
    data: JSON.stringify(data)
  };
};

export const requestOptionsPOSTFile = (propsToken = undefined) => {
  let token;
  if (propsToken) token = propsToken;
  else token = sessionStorage.getItem('token');
  return {
    method: 'POST',
    headers: {
      Authorization: `${token}`,
      "Content-Type": "multipart/form-data",
    },
  };
};

export const monthNames = ["Januari", "Februari", "Maret", "April", "Mei", "Juni",
  "Juli", "Agustus", "September", "Oktober", "November", "Desember"
];

export const numberWithCommas = (x) => {
  return x?.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ".");
}

export const checkValue = (value) => {
  if (value === null || value === '' || value === undefined) {
    return '-'
  } else {
    return value
  }
}

const d = new Date();
export const bulan = monthNames[d.getMonth()];

export const getAvatar = (link) => {
  let baseUrl = process.env.REACT_APP_BASE_URL || 'https://apigw.kubekkp.coofis.com/';
  return baseUrl + 'bridge' + link;
}

// API CONSTANT
const OO_DOC_SERVER = process.env.REACT_APP_OO_DOC_SERVER || 'https://oo.armsolusi.com/';
// Addressbook
export const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://apigw.kubekkp.coofis.com/';
const BASE_URL_MOCK = '/';
// const TITLE_TREE = BASE_URL_MOCK + 'addressbook/titles/';
const TITLE_TREE = BASE_URL + 'bridge/addressbook/division/';
// const TITLE_TREE_ID = BASE_URL_MOCK + 'addressbook/titles/$id';
const TITLE_TREE_ID = BASE_URL + 'bridge/addressbook/tree/$id/';
// const EMPLOYEES = BASE_URL_MOCK + 'addressbook/employees/';'bridge/addressbook/employees/';
const EMPLOYEES = BASE_URL + 'bridge/addressbook/employee/';
const PERSONALS = BASE_URL_MOCK + 'addressbook/personals/';
const ADD_PERSONAL = BASE_URL_MOCK + 'addressbook/personals/add/';
const DELETE_PERSONAL = BASE_URL_MOCK + 'addressbook/personals/delete/';
const LOG_OUT_URL = process.env.REACT_APP_LOG_OUT || 'https://auth.kubekkp.coofis.com/token/logout/';

//PROFILE KNOWLEDGE
const PROFILE_MP_LOGIN = BASE_URL + 'mp/profile/';
const PROFILE_ID = BASE_URL + 'mp/profile/$id';
const PROFILE_ID_ARTICLE = BASE_URL + 'mp/profile/$id/article/';
const PROFILE_ID_ACTIVITY = BASE_URL + 'mp/profile/$id/activity/';

//KNOWLEDGE MANAGEMENT
const LINIMASA = BASE_URL + 'mp/linimasa/';
const LINIMASAPOP = BASE_URL + 'mp/linimasa/popular/';
const LIKEARTICLE = BASE_URL + '/mp/linimasa/$id/like/';
const DISLIKEARTICLE = BASE_URL + '/mp/linimasa/$id/unlike/';
const LINIMASADETAIL = BASE_URL + 'mp/linimasa/$id';
const LINIMASAADDCOMMENT = BASE_URL + 'mp/linimasa/comment/';
const LINIMASAOTHERPOST = BASE_URL + 'mp/profile/$id/article/?limit=5';
const LISTVIEWEDPOST = BASE_URL + 'mp/linimasa/$id/view/list/';
const LISTLIKEDPOST = BASE_URL + 'mp/linimasa/$id/like/list/';

// KNOWLEDGE MANAGEMENT MYPOST
const CHART_VIEW = BASE_URL + 'mp/mypost/chart/view/?year=';
const CHART_POINT = BASE_URL + 'mp/mypost/chart/point/?year=';
const CHART_POST = BASE_URL + 'mp/mypost/chart/post/?year=';
const CHART_LIKE = BASE_URL + 'mp/mypost/chart/like/?year=';
const CHART_COUNT = BASE_URL + 'mp/mypost/chart/count/?year=';
const MYPOST_LIST = BASE_URL + 'mp/mypost/';
const DELETE_MYPOST_ID = BASE_URL + 'mp/$id/destroy/';
const POST_MY_ARTICLE = BASE_URL + 'mp/publish/create/';
const POST_MY_ARTICLE_DRAFT = BASE_URL + 'mp/draft/create/';
const ADD_ATTACHMENT = BASE_URL + 'mp/attachment/create/';
const GET_DETAIL = BASE_URL + 'mp/mypost/$id';
const UPDATE_MYPOST = BASE_URL + 'mp/publish/$id/update/';
const UPDATE_MYPOST_DRAFT = BASE_URL + 'mp/draft/$id/update/';

//KNOWLEDGE ADMIN
const ADMINPENILAIAN = BASE_URL + 'mp/admin/evaluation/';
const ADMINPENILAIANFILTER = BASE_URL + 'mp/admin/evaluation/?general=';
const ADMINREVIEWCOUNT = BASE_URL + 'mp/admin/evaluation/count/?year=$year&quarter=$quarter';
const ADMINPENILAIANID = BASE_URL + 'mp/admin/evaluation/$id';
const ADMINADDSCORE = BASE_URL + 'mp/admin/evaluation/$id/score/';
const ADMINGETKATEGORI = BASE_URL + 'mp/admin/category/?type=penilai&limit=';
const ADMINADDKATEGORI = BASE_URL + 'mp/admin/category/';
const ADMINDELETEKATEGORI = BASE_URL + 'mp/admin/category/$id';
const ADMINUPDATEKATEGORI = BASE_URL + 'mp/admin/category/$id';
const ADMINADDSCOREALL = BASE_URL + 'mp/admin/evaluation/score/';
const ADMINGETKOMPETENSI = BASE_URL + 'mp/admin/competence/?limit=';
const ADMINADDKOMPETENSI = BASE_URL + 'mp/admin/competence/?limit=';
const ADMINUPDATEKOMPETENSI = BASE_URL + 'mp/admin/competence/$id';
const ADMINDELETEKOMPETENSI = BASE_URL + 'mp/admin/competence/$id';
const ADMINPENILAIANCANCEL = BASE_URL + 'mp/admin/evaluation/$id/score/cancel/';
const ADMINPENILAIANTAKEDOWN = BASE_URL + 'mp/admin/evaluation/$id/cancel/';
// ADMIN PENILAIAN KOMENTAR
const ADMINPENILAIANKOMENTAR = BASE_URL + 'mp/linimasa/comment/penilaian/';

// KNOWLEDGE ADMIN RANGKUMAN
const SUMMARY_TOTAL_POST = BASE_URL + 'mp/admin/summary/total-post/?year=$year&quarter=$quarter';
const SUMMARY_GRAPH = BASE_URL + 'mp/admin/summary/graph/?year=$year&quarter=$quarter';
const SUMMARY_ACCUMULATION = BASE_URL + 'mp/admin/summary/accumulation/?year=$year&quarter=$quarter';
const SUMMARY_REVIEW = BASE_URL + 'mp/admin/summary/review/?year=$year&quarter=$quarter';
const EXPORT_FILE_BY_QUARTER = BASE_URL + 'mp/admin/summary/export/users-by-quarter/';
const EXPORT_FILE_BY_EMPLOYEE = BASE_URL + 'mp/admin/summary/export/pegawai/';
const SUMMARY_BAD_USER = BASE_URL + 'mp/admin/summary/bad-user/';

//PORTAL BANNER
const PORTALBANNER = BASE_URL + 'bridge/home/benner/';
const PORTALNEWS = BASE_URL + 'bridge/home/news/';
const SATKERBANNER = BASE_URL + 'bridge/satker/benner/';
const SATKERBIRTHDAY = BASE_URL + 'bridge/satker/birthday/';
const SATKERPESANDIRJER = BASE_URL + 'bridge/satker/pesan/';
const SATKERGALLERY = BASE_URL + 'bridge/satker/gallery/';
const SATKERNEWS = BASE_URL + 'bridge/satker/news/';
const PORTALNEWSID = BASE_URL + 'bridge/home/news/$id/';
const SATKERNEWSID = BASE_URL + 'bridge/satker/news/$id/';

//PORTAL GALLERY
const PORTALGALLERY = BASE_URL + 'bridge/home/gallery/';

//PORTAL ANNOUNCEMENT
const GETANNOUNCEMENT = BASE_URL + 'bridge/home/announcement/';
const POSTANNOUNCEMENT = BASE_URL + 'bridge/home/announcement/';
const UPDATEANNOUNCEMENT = BASE_URL + 'bridge/home/announcement/$id'

// PORTAL NOTIFICATIONS
const GET_NOTIFICATIONS = BASE_URL + 'bridge/notification/list/';
const READ_NOTIFICATIONS = BASE_URL + 'bridge/notification/$id/read/';
const GET_COUNT_NOTIFICATIONS = BASE_URL + 'bridge/notification/count/';

const BASE_URL_AVATAR = BASE_URL + 'bridge';
const LINIMASAACTIVEUSER = BASE_URL + 'mp/linimasa/user-activate/';

//REPOSITORY
const DOCUMENTS = BASE_URL + 'repository/my-documents/?page=$page&published=$published&public=$public&general=$general&by_title=$byTitle&unker=$unker&satker=$satker';
const SHARE_DOCUMENTS = BASE_URL + 'repository/shared-documents/?page=$page';
const ADD_DOCUMENT_ATTACHMENT = BASE_URL + 'repository/attachment/';
const DELETE_DOCUMENT_ATTACHMENT = BASE_URL + 'repository/documents/$id/delete-attachment/';
const ADD_DOCUMENT = BASE_URL + 'repository/document-share/';
const ADD_DOCUMENT_BPK = BASE_URL + 'repository/document-share-bpk/';
const EDIT_DOCUMENT = BASE_URL + 'repository/$id/document-edit/';
const DETAIL_DOCUMENT = BASE_URL + 'repository/$id/document-detail/';
const DELETE_DOCUMENT = BASE_URL + 'repository/$id/document-delete/';
const ADD_COMMENT = BASE_URL + 'repository/document-comment/';
const FILTER_DOCUMENT = BASE_URL + 'repository/my-documents/?published=$published&public=$public&general=$value&by_title=$byTitle&unker=$unker&satker=$satker';
const FILTER_SHARE_WITH_ME = BASE_URL + 'repository/shared-documents/?general=$value';
const DOWNLOAD_ATTACHMENT = BASE_URL + 'repository/attachment/$id/download/'
const RATE_DOCUMENT = BASE_URL + 'repository/$id/rate/'
const UPDATE_DOCUMENT_ATTACHMENT = BASE_URL + 'repository/attachment/$id/update/'
const ATTACHMENT_VIEW = BASE_URL + 'repository/attachment/$id/view/'
const UPDATE_STATE_DOCUMENT = BASE_URL + 'repository/$id/update-state/'
const GET_DOCUMENT_COUNTER = BASE_URL + 'repository/document-count/?tipe_dokumen=$tipe'

// NOTULENSI
const GET_NOTULENSI = BASE_URL + 'repository/my-documents/?notulensi=true&page=$page&published=$published&public=false&general=$general';
const GET_SHARED_NOTULENSI = BASE_URL + 'repository/shared-documents/?notulensi=true&page=$page&tipe=done';
const UPDATE_NOTULENSI = BASE_URL + 'repository/$id/document-edit/';

//DASHBOARD
const INFOGRAFIS = BASE_URL + '/bridge//infografis/?source=$value&page=$page&limit=$limit';
const TEKNOLOGI_TERBARU = BASE_URL + '/bridge//teknologi-terkini/?page=$page&limit=$limit';
const GET_EMPLOYEE = BASE_URL + 'mp/admin/iku/employee/?page=$page&limit=$limit&year=$year&unit_kerja=$unker&quarter=$quarter&memenuhi=$status&general=$general';
const GET_UNIT_KERJA = BASE_URL + 'mp/admin/iku/unitkerja-choice/';
const GET_DETAIL_EMPLOYEE = BASE_URL + 'mp/admin/iku/employee/$id';
const GET_MOBILE_APP = BASE_URL + 'bridge/mobile-download/?app_type=$appType';
const GET_DOWNLOAD_MONITORING = BASE_URL + 'mp/admin/iku/employee/export/?year=$year&unit_kerja=$unker&quarter=$quarter&memenuhi=$status&general=$general';
const GET_DOWNLOAD_MONITORING_V2 = BASE_URL + 'mp/admin/iku/employee/export/v2/?year=$year&unit_kerja=$unker&quarter=$quarter&memenuhi=$status&general=$general';
const GET_EMPLOYEE_V2 = BASE_URL + 'mp/admin/iku/employee/v2/?page=$page&limit=$limit&year=$year&unit_kerja=$unker&quarter=$quarter&memenuhi=$status&general=$general';

//ROLE
const GET_LIST_ROLE_URL = BASE_URL + 'bridge/role/';


// PEGAWAI
const GET_LIST_PEGAWAI_URL = BASE_URL + '/bridge/profile/all/?limit=10&offset=';
const GET_FILTER_PEGAWAI_URL = BASE_URL + '/bridge/profile/all/?search=$filter';
const GET_DETAIL_PEGAWAI_URL = BASE_URL + 'bridge/profile/:nik';
const PUT_PROFILE_ME = BASE_URL + 'bridge/profile/me/update-meta/';
//ADMINTOOLS
const GET_PROFILE_ADMINTOOLS = BASE_URL + 'bridge/admintools/profile/'
const GET_JOBS_ADMINTOOLS = BASE_URL + 'bridge/admintools/jobs/list/'
const GET_JOBS_DETAIL = BASE_URL + 'bridge/admintools/jobs/{id}/view'
const GET_LOGS = BASE_URL + 'log/'
const GET_LOGS_NOTIFICATION = BASE_URL + 'notification/history'
const GET_LOGS_SERVICE_DIGISIGN = BASE_URL + 'digitalsign/log-digitalsign/'
const GET_TEMPLATE = BASE_URL + 'bridge/admintools/nde/template-letter/'

const GET_JOBS_OPTION_ADMINTOOLS = BASE_URL + 'bridge/admintools/jobs/options/'
const POST_JOBS_TRIGGER_ADMINTOOLS = BASE_URL + 'bridge/admintools/jobs/trigger/'

const ACTIVATE_PROFILE_ADMINTOOLS = BASE_URL + 'bridge/admintools/profile/{id}/activate/'
const DEACTIVATE_PROFILE_ADMINTOOLS = BASE_URL + 'bridge/admintools/profile/{id}/deactivate/'
const ACTIVATE_TITLE_ADMINTOOLS = BASE_URL + 'bridge/admintools/title/{id}/activate/'
const DEACTIVATE_TITLE_ADMINTOOLS = BASE_URL + 'bridge/admintools/title/{id}/deactivate/'
const GET_TITLE_OPTIONS = BASE_URL + "bridge/transform/title/";

const GET_TITLE_ADMINTOOLS = BASE_URL + 'bridge/admintools/title/'
const GET_SATKER_ADMINTOOLS = BASE_URL + 'bridge/admintools/division/'
const UPDATE_SPECIMENT = BASE_URL + 'digitalsign/profile_sign/{nip}/update/'
const PROFILE_SPECIMENT = BASE_URL + 'digitalsign/profile_sign/{nip}/profile/'
const TITLE_SPECIMENT = BASE_URL + 'digitalsign/title_sign/update/'

const GET_KM_MASTER_DATA = BASE_URL + 'bridge/admintools/km/'
const GET_NOTATINDAKAN_MASTER_DATA = BASE_URL + 'bridge/admintools/action/'

const GET_ORGANIZATION_ADMINTOOLS = BASE_URL + 'bridge/admintools/organization/'

const GET_DEPARTMENT_MASTER_DATA = BASE_URL + 'bridge/admintools/department/'
const POST_RESET_PASSWORD = BASE_URL + 'bridge/admintools/profile/{id}/reset-password/'
const POST_EXPORT_PROFILE = BASE_URL + 'bridge/admintools/profile/bulk/export/'
const GET_OWN_ADMINTOOLS = BASE_URL + "bridge/admintools/nde/operator-numbers/own/"
const UPDATE_SEQUENCE = BASE_URL + "bridge/admintools/nde/operator-numbers/sequence-update/:id/"
const GET_PENOMORAN_TREE_ADMINTOOLS = BASE_URL + "bridge/admintools/nde/operator-numbers/tree/:id/"
const GET_PENOMORAN_LIST_ADMINTOOLS = BASE_URL + "bridge/admintools/nde/operator-numbers/list/:id/"
const GET_KM_PENOMORAN_ADMINTOOLS = BASE_URL + "bridge/admintools/nde/addressbook/km/tree/";
const GET_DIVISIONS_ADMINTOOLS = BASE_URL + "bridge/admintools/nde/addressbook/division/";
const GET_DIVISIONS_ADMINTOOLS_DEPARTMENT = BASE_URL + "bridge/admintools/nde/addressbook/division/:id/department/";
const GET_DIVISIONS_ADMINTOOLS_DEPARTMENT_LEADER = BASE_URL + "bridge/admintools/nde/addressbook/department/:id/leader/";
const GET_DIVISIONS_AUTOCOMPLETE_ADMINTOOLS = BASE_URL + "bridge/admintools/division/";
const GET_DIVISIONS_OPTIONS = BASE_URL + "bridge/master/division/";
const GET_FAQ = BASE_URL + "bridge/admintools/faq/"
const GET_FAQ_CATEGORIES = BASE_URL + "bridge/admintools/faq/category/"
const GET_FAQ_GROUPS = BASE_URL + "bridge/admintools/faq/group/"



const GET_PENANDATANGAN_PENOMORAN_ADMINTOOLS = BASE_URL + "bridge/admintools/nde/addressbook/title/tree/$id/";
const GET_PENANDATANGAN_OPERATOR = BASE_URL + "bridge/admintools/nde/addressbook/sender/{operator_id}/";
const GET_PENANDATANGAN_SCAN = BASE_URL + "bridge/admintools/nde/addressbook/sender-scan/{operator_id}/";
const GET_EMPLOYEE_PENOMORAN_ADMINTOOLS = BASE_URL + "bridge/admintools/nde/addressbook/employee/";
const GET_JENIS_SURAT_ADMINTOOLS = BASE_URL + "bridge/admintools/nde/addressbook/template/{template_name}/";
const GET_TYPE_SURAT_ADMINTOOLS = BASE_URL + "bridge/admintools/nde/addressbook/type-letter/:id/:template/";
const POST_SET_PENOMORAN_ADMINTOOLS = BASE_URL + "bridge/admintools/nde/operator-numbers/set/{ref_number_id}/";
const POST_PENOMORAN_ADMINTOOLS = BASE_URL + "bridge/admintools/nde/operator-numbers/book/:id/";
const POST_PENOMORAN_MANUAL_ADMINTOOLS = BASE_URL + "bridge/admintools/nde/operator-numbers/create-manual/:id/";
const POST_PREVIEW_ADMINTOOLS = BASE_URL + "bridge/admintools/nde/operator-numbers/preview/:id/";
const GET_PENOMORAN_SCAN_SURAT = BASE_URL + "bridge/admintools/nde/addressbook/refnumber-scan/:id_operator/";
// bridge/admintools/nde/addressbook/refnumber-scan/:id_operator/?date=2023-12-06&template=nota_internal&division=division_id
const GET_SCAN_SURAT_MASUK = BASE_URL + "bridge/admintools/nde/scan/";
const POST_SCAN_SURAT_MASUK = BASE_URL + "bridge/admintools/nde/scan/submit/";
const POST_SCAN_SURAT_KELUAR = BASE_URL + "bridge/admintools/nde/scan-out/";
const UPDATE_REF_NUMBER = BASE_URL + 'bridge/admintools/nde/operator-numbers/edit/:id/';
const UPLOAD_DRAFT = BASE_URL + 'bridge/admintools/nde/scan/upload-draft/:id/';
const POST_ATTACHMENTS = BASE_URL + "bridge/admintools/nde/attachments/create";
const ADD_ATTACHMENT_NEW = BASE_URL + 'crsbe/attachment/upload';




//CHAT
const GET_ROOMS = BASE_URL + 'chuaks/room/';
const GET_CHAT = BASE_URL + 'chuaks/chat/$id/';
const CREATE_CHAT = BASE_URL + 'chuaks/chat/';
const CREATE_ROOM = BASE_URL + 'chuaks/room/';
const CHAT_WEB_SOCKET = process.env.REACT_APP_CHAT_WEB_SOCKET || 'wss://broker.emqx.io:8084/mqtt';
const CHAT_API = BASE_URL + 'chuaks';

// DIGITAL SIGN
const URL = BASE_URL + 'digitalsign/';
const GET_SERTIFIKAT_EXTERNAL = URL + 'external-certificate/?page=$page&limit=$limit&type=$type';
const GET_DETAIL_SERTIFIKAT_EXTERNAL = URL + 'external-certificate/$id/';
const GET_LIST_COMPOSER = URL + 'document/composer/?tipe_dokumen=$tipe&page=$page&limit=$limit';
const GET_LIST_REVISION = URL + 'document/revisi/?tipe_dokumen=$tipe&page=$page&limit=$limit';
const GET_LIST_GET_NUMBER = URL + 'document/get-number/?tipe_dokumen=$tipe&page=$page&limit=$limit';
const GET_LIST_INPROGRESS = URL + 'document/inprogress/?tipe_dokumen=$tipe&page=$page&limit=$limit';
const GET_LIST_READY = URL + 'document/ready/?tipe_dokumen=$tipe&page=$page&limit=$limit';
const GET_LIST_COMPLETED = URL + 'document/completed/?tipe_dokumen=$tipe&page=$page&limit=$limit';
const GET_LIST_DRAFT = URL + 'document/draft/?tipe_dokumen=$tipe&page=$page&limit=$limit';
const GET_LIST_APPROVAL_SK = URL + 'document/sk-need-approval/?tipe_dokumen=$tipe&page=$page&limit=$limit';
const GET_LIST_INBOX_PK = URL + 'document/pk/?tipe_dokumen=$tipe&page=$page&limit=$limit';

const GET_LIST_NEED_SIGN_SK = URL + 'document/sk-need-sign/?tipe_dokumen=$tipe&page=$page&limit=$limit';
const GET_PERIZINAN_ESEA_COUNT = URL + 'perizinan-count/';
const ADD_DOCUMENT_DIGISIGN = URL + 'document/create/';
const ADD_DOCUMENT_DIGISIGN_PK = URL + 'document/pk/upload/';

const ADD_DOCUMENT_BANKOM_DIGISIGN = URL + '/to-pdf/';
const REJECT_DOCUMENT_DIGISIGN = URL + 'document/reject_document/';
const PUT_DOCUMENT_DIGISIGN = URL + 'document/$id/draft/';
const PUT_DOCUMENT_DIGISIGN_PK = URL + 'document/$id/inprogress/';

const PUT_DOCUMENT_DIGISIGN_RETURN_PK = URL + 'document/return/';
const PUT_DOCUMENT_DIGISIGN_RETURN_SK = URL + 'document/return/';
const PUT_DOCUMENT_DIGISIGN_CANCEL_PK = URL + 'document/reject/';

const ADD_ATTACHMENT_DIGISIGN = URL + 'attachment/create/';
const ADD_ATTACHMENT_SERTIFIKAT_EXTERNAL_DIGISIGN = URL + 'external-certificate-attachment/';
const GET_DETAIL_DIGISIGN = URL + 'document/$id';
const GET_DOKUMEN_SK_PYB = BASE_URL + 'cuti/get-pyb-digitalsign/';
const GET_DOKUMEN_SK_PYB_PPID = BASE_URL + 'cuti/get-pyb-ppid/';
const GET_DOKUMEN_PK_PYB = BASE_URL + 'cuti/get-pyb-pppk/';

const EXPORT_DOKUMEN_PK = BASE_URL + 'digitalsign/export-dokumen-pk/';
const EXPORT_DOKUMEN_SK = BASE_URL + 'digitalsign/export-sk/';
const GET_DOKUMEN_COUNTER = BASE_URL + 'digitalsign/document-counter/';
const GET_DASHBOARD_COUNT_DOKUMEN = BASE_URL + 'digitalsign/dashboard-monitor-count/';


const UPDATE_DOKUMEN_DIGISIGN = URL + 'document/$id/draft/';
const PUT_INPROGRESS_BANKOM_DIGISIGN = URL + 'document/approve/';
const PUT_INPROGRESS_DOKUMENSK_DIGISIGN = URL + 'document/approve2/';
const PUT_INPROGRESS_DOKUMENLAIN_DIGISIGN = URL + 'document/approve2/';
const PUT_INPROGRESS_SM_DIGISIGN = URL + 'sertif-mkp/approve/';
const GET_LIST_COURSE_DIGISIGN = URL + '/course/?limit=';
const GET_DETAIL_COURSE_DIGISIGN = URL + '/course/$id/';
const GET_PENERIMA_SERTIF_BY_COURSE = URL + '/completed_users/?course_id=$id';
const GET_LIST_REJECTED_DIGISIGN = URL + 'document/rejected/?page=$page';
const GET_LIST_REVISI_DIGISIGN = URL + 'document/revisi/?page=$page';
const GET_LIST_REJECTED_PERIZINAN_DIGISIGN = URL + 'document/rejected/?page=$page';
const GET_LIST_SIGNED_DIGISIGN = URL + 'document/signed/?tipe_dokumen=$tipe&page=$page&limit=$limit';
const GET_LIST_RETRY_DIGISIGN = URL + 'document/retry/?tipe_dokumen=$tipe&page=$page&limit=$limit';
const GET_SUMMARY_COUNT = URL + 'document/summary/';
const GET_SUMMARY_LIST = URL + 'document/summary/list/?page=$page&sertifikat=$sertifikat&pelatihan=$pelatihan&judul=$judulPelatihan';
const GET_SUBJECT_LIST = URL + 'subject-list/?pelatihan=$pelatihan';
const GET_EXPORT_SUMMARY_LIST = URL + 'export/?judul=$judulPelatihan';
const GET_TEMPLATE_DIGISIGN = URL + '/document/template/';
const CHECK_PDF_DIGISIGN = URL + 'check-pdf/';
const POST_OVERRIDE_USER_DIGISIGN = URL + 'overide-user/';
const UPDATE_EVALUASI_DIGISIGN = URL + 'course/$id/';
const PARAF_DIGISIGN = URL + 'document/paraf/';
const PENOMORAN_DIGISIGN = URL + 'perizinan-penomoran/?jenis_dokumen=$jenis_dokumen&tanggal=$tanggal';
const REJECT_PERIZINAN_DIGISIGN = URL + 'document/reject/';
const GET_LIST_TRACK_DIGISIGN = URL + 'document/track/?page=$page&limit=$limit';
const GET_PERIZINAN_PKRL_COUNT = URL + 'pkrl-count/';
const PARAF_BEFORE_TTDE_DIGISIGN = URL + 'document/prepare-ttde/';
const GET_LIST_LAPORAN_PKRL = URL + 'document/laporan-pkrl/?tipe_dokumen=$tipe&page=$page';
const DOWNLOAD_DASHBOARD_LAPORAN_PKRL = URL + 'export-pkrl/?direktorat=$direktorat&kategori=$kategori';
const DOWNLOAD_LAPORAN_PKRL = URL + 'export-pkrl/?state=$state';
const DELETE_DOCUMENT_DIGISIGN = URL + 'document/$id'
const GET_MONITORING_LIST_DIGISIGN = URL + 'main-list/?type=$type&page=$page&limit=$limit';
const GET_MONITORING_DASHBOARD_DIGISIGN = URL + 'main-dashboard/';
const GET_SIAPMUTU_COUNT = URL + 'siapmutu-count/';
const GET_TEMPLATE_RECEIVERS_BANKOM = URL + 'csv-template/';
const GET_DETAIL_PEGAWAI_SIPEG = BASE_URL + '/sipeg/external/pegawai/drh/:nik/'

const POST_TRIGGER_DIGISIGN = BASE_URL + 'mp/triger-user/';

const GET_COUNTER_DIGISIGN = URL + 'document-counter/?type=$type';

//SERTIFIKAT MENTERI
const ADD_CSV_TO_JSON_DIGISIGN = URL + 'csv-to-json/';
const GET_LIST_COMPOSER_SM = URL + 'sertif-mkp/composer/?page=$page&limit=$limit';
const GET_LIST_INPROGRESS_SM = URL + 'sertif-mkp/inprogress/?page=$page&limit=$limit';
const GET_LIST_READY_SM = URL + 'sertif-mkp/ready/?page=$page&limit=$limit';
const GET_LIST_COMPLETED_SM = URL + 'sertif-mkp/completed/?page=$page&limit=$limit';

// PRODUK LPMUKP
const GET_LIST_DOKUMEN_LPMUKP = BASE_URL + 'digitalsign/lpmukp/document/';
const GET_DETAIl_DOKUMEN_LPMUKP = BASE_URL + 'digitalsign/document/$id';

// ROLE
const CREATEROLE = BASE_URL + 'bridge/role/create/';
const ADDMEMBERROLE = BASE_URL + 'bridge/role/$id/add_member/';
const DELETEMEMBERROLE = BASE_URL + 'bridge/role/$id/delete_member/';
const LISTROLE = BASE_URL + 'bridge/role/';
const DETAILROLE = BASE_URL + 'bridge/role/$id/';
const UPDATEROLE = BASE_URL + 'bridge/role/update/$id/';
const DELETEROLE = BASE_URL + 'bridge/role/delete/$id/';
const IMPORTROLE = BASE_URL + 'bridge/role/import/';
const EXPORTROLE = BASE_URL + 'bridge/role/export/';
const DELETEMULTIPLEROLE = BASE_URL + 'bridge/role/multi-delete/';
const LISTSERVICEROLE = BASE_URL + 'bridge/role/service/';
//TASK MANAGEMENT
const GET_TREE_TM = BASE_URL + 'calendar/project/tree/?sort=$sort';
const GET_LIST_TM = BASE_URL + 'calendar/list-task/$id/retrieve/';
const GET_DASHBOARD_TM = BASE_URL + 'calendar/dashboard/list/?project_id=$project_id&status=$status&my_task=$my_task';
const GET_KORESPONDENSI_TM = BASE_URL + 'bridge/integration/nde/todo/$status'
const GET_DASHBOARD_COUNT_TM = BASE_URL + 'calendar/dashboard/count/?project_id=$project_id&my_task=$my_task';
const GET_MONITORING_TM = BASE_URL + 'calendar/task/completed/?project_id=$project_id&general=$general';
const GET_PROJECT_CHOICE_TM = BASE_URL + 'calendar/project/choice/';
const GET_MY_TASK_COUNT_TM = BASE_URL + 'calendar/mytask/count/?project_id=$project_id';
const GET_PROJECT_DETAIL_TM = BASE_URL + 'calendar/project/$id/retrieve/';
const GET_TASK_DETAIL_TM = BASE_URL + 'calendar/task/$id/retrieve/';
const GET_TASK_DETAIL_KORESPONDENSI_TM = BASE_URL + 'bridge/integration/nde/todo/$id/';
const GET_EXPORT_MONITORING_TM = BASE_URL + 'calendar/export/';
const ADD_CATEGORY = BASE_URL + 'calendar/project/create/';
const PUT_CATEGORY = BASE_URL + 'calendar/project/$id/update/';
const DELETE_CATEGORY = BASE_URL + 'calendar/project/$id/destroy/';
const ADD_FOLDER = BASE_URL + 'calendar/folder/create/';
const ADD_LIST = BASE_URL + 'calendar/list-task/create/';
const PUT_LIST = BASE_URL + 'calendar/list-task/$id/update/';
const DELETE_LIST = BASE_URL + 'calendar/list-task/$id/destroy/';
const ADD_TASK = BASE_URL + 'calendar/task/create/';
const PUT_TASK = BASE_URL + 'calendar/task/$id/update/';
const UPDATE_STATUS_TASK = BASE_URL + 'calendar/card/$id/update/';
const UPDATE_STATUS_KORESPONDENSI = BASE_URL + 'bridge/integration/nde/todo/$id/mark/';
const ADD_ATTACHMENT_TM = BASE_URL + 'calendar/attachment/create/';
const ADD_COMMENT_TM = BASE_URL + 'calendar/comment/create/';
const DELETE_TASK_TM = BASE_URL + 'calendar/task/$id/destroy/';
// EVENT MANAGEMENT
const EVENTCREATE = BASE_URL + 'calendar/event/create/';
const EVENT = BASE_URL + 'calendar/event/';
const EVENTTODAY = BASE_URL + 'calendar/event/today/';
const EVENTID = BASE_URL + 'calendar/event/$id/retrieve/';
const EVENTUPDATE = BASE_URL + 'calendar/event/$id/update/';
const EVENTUPDATESTATUS = BASE_URL + 'calendar/event/$id/status/';
const EVENTDELETE = BASE_URL + 'calendar/event/$id/destroy/';
const EVENTLISTPROGRESS = BASE_URL + 'calendar/event/progress/';
const AGENDACREATE = BASE_URL + 'calendar/event/agenda/create/';
const AGENDA = BASE_URL + 'calendar/event/$id/agenda/';
const AGENDAID = BASE_URL + 'calendar/event/agenda/$id/retrieve/';
const AGENDAUPDATE = BASE_URL + 'calendar/event/agenda/$id/update/';
const AGENDADELETE = BASE_URL + 'calendar/event/agenda/$id/destroy/';
const NOTULENSICREATE = BASE_URL + 'calendar/event/agenda/notulensi/create/';
const NOTULENSI = BASE_URL + 'calendar/event/agenda/$id/notulensi/';
const NOTULENSIID = BASE_URL + 'calendar/event/agenda/notulensi/$id/retrieve/';
const NOTULENSIUPDATE = BASE_URL + 'calendar/event/agenda/notulensi/$id/update/';
const NOTULENSIDELETE = BASE_URL + 'calendar/event/agenda/notulensi/$id/destroy/';
const NOTULENSIAPPROVE = BASE_URL + 'calendar/event/agenda/notulensi/$id/approve/';
const NOTULENSIREADYTOAPPROVE = BASE_URL + 'calendar/event/agenda/notulensi/$id/ready/';
const PRESENSI = BASE_URL + 'calendar/event/agenda/$id/presensi/';
const PRESENSIID = BASE_URL + 'calendar/event/agenda/presensi/$id/retrieve/';
const PRESENSIUPDATE = BASE_URL + 'calendar/event/agenda/presensi/$id/update/';
const PRESENSIDELETE = BASE_URL + 'calendar/event/agenda/presensi/$id/destroy/';
const ATTACHMENTCREATE = BASE_URL + 'calendar/attachment/create/';
const TASKCREATE = BASE_URL + 'calendar/event/agenda/notulensi/task/create/';
const TASK = BASE_URL + 'calendar/event/agenda/notulensi/$id/task/';
const TASKID = BASE_URL + 'calendar/event/agenda/notulensi/task/$id/retrieve/';
const TASKUPDATE = BASE_URL + 'calendar/event/agenda/notulensi/task/$id/update/';
const TASKDELETE = BASE_URL + 'calendar/event/agenda/notulensi/task/$id/destroy/';
const APPROVER = BASE_URL + 'calendar/event/agenda/notulensi/$id/approver/';
const COMMENTADDEM = BASE_URL + 'calendar/event/agenda/notulensi/task/comment/create/';
const AGENDAUPDATESTATE = BASE_URL + 'calendar/event/agenda/$id/done/';
const EVENTCHOISECALENDER = BASE_URL + 'calendar/calendar/choice/';
const EVENTNOTIFICATION = BASE_URL + 'calendar/event/$id/notification/';
const AGENDANOTIFICATION = BASE_URL + 'calendar/event/agenda/$id/notification/';
const SPESIMENID_TITLE = BASE_URL + 'digitalsign/profile_sign/$id/jabatan/';
const SPESIMENID_EMPLOYEE = BASE_URL + 'digitalsign/profile_sign/$id/profile/';

// GRUP KALENDER
const GET_LIST_GRUP_KALENDER = BASE_URL + 'calendar/calendar/?limit=$limit';
const GET_LIST_ACARA = BASE_URL + 'calendar/calendar/$id/event/';
const GET_PIC_ACARA = BASE_URL + 'calendar/calendar/$id/pic/';
const CREATE_GRUP_KALENDER = BASE_URL + 'calendar/calendar/create/';
const CREATE_ACARA = BASE_URL + 'calendar/calendar/event/create/';
const GET_DETAIL_ACARA = BASE_URL + 'calendar/calendar/event/$id/retrieve/';
const GET_DETAIL_GRUP = BASE_URL + 'calendar/calendar/$id';
const UPDATE_GRUP_KALENDER = BASE_URL + 'calendar/calendar/$id/update/';
const UPDATE_EVENT_KALENDER = BASE_URL + 'calendar/calendar/event/$id/update/';
const DELETE_GRUP_KALENDER = BASE_URL + 'calendar/calendar/$id/destroy/';
const DELETE_EVENT_KALENDER = BASE_URL + 'calendar/calendar/event/$id/destroy/';
const GET_LIST_ACARA_EVENT = BASE_URL + 'calendar/calendar/agenda/?calendar_id=';
const GET_DETAIL_ACARA_EVENT = BASE_URL + 'calendar/event/$id/retrieve/';
const GET_LIST_SUBAGENDA_EVENT_KALENDER = BASE_URL + 'calendar/event/$id/agenda/';
const GET_LIST_ACARA_PERSONAL = BASE_URL + 'calendar/calendar/event/korespondensi/';
const GET_DETAIL_ACARA_PERSONAL = BASE_URL + 'calendar/calendar/event/$id/retrieve/korespondensi/';
const GET_TOKEN_CRSFE_KALENDER = BASE_URL + 'crsbe/external/profile/exchange-token/';

// KM Filter
const GETKATEGORI = BASE_URL + 'mp/admin/category/';
const GETKOMPETENSI = BASE_URL + 'mp/admin/competence/';
const GETSATKERBYUNKER = BASE_URL + 'bridge/master/department-div/$id/';
const GETUNKER = BASE_URL + 'bridge/master/division/';

//SURVEY
const ADD_SURVEY = BASE_URL + 'bridge/survey/'
const GET_SURVEY_REPORT = BASE_URL + 'bridge/survey-report/?page=$page'
const GET_SURVEY_COUNT = BASE_URL + 'bridge/survey-count/'
const GET_SURVEY_DETAIL = BASE_URL + 'bridge/survey-detail/$id/'
const GET_SURVEY_EXPORT = BASE_URL + 'bridge/export-survey-response/?year=$year'

//INFORMASI
const GET_LIST_AKSI_PERUBAHAN = BASE_URL + 'bridge/transform/?query=$query';
const POST_AKSI_PERUBAHAN = BASE_URL + 'bridge/transform/';

// export excel penomoran
const EXPORT_SCAN_IN = BASE_URL + 'bridge/admintools/nde/scan/export-in/';
const EXPORT_SCAN_OUT = BASE_URL + 'bridge/admintools/nde/scan/export-out/';
const EXPORT_PENOMORAN = BASE_URL + 'bridge/admintools/nde/operator-numbers/export/:id/';

// PRESENSI
const GET_LIST_PRESENSI = BASE_URL + '/attendence/report/';
const GET_LAST_LOG = BASE_URL + '/attendence/lastlog/';

// group addressbook
const LIST_GROUP_ADDR = BASE_URL + 'bridge/admintools/nde/group/list/:operator_id/';
const EDIT_GROUP_ADDR = BASE_URL + 'bridge/admintools/nde/group/edit/:id/';
const ADD_GROUP_ADDR = BASE_URL + 'bridge/admintools/nde/group/add/:operator_id/';
const DETAIL_GROUP_ADDR = BASE_URL + 'bridge/admintools/nde/group/view/:id/';
const DELETE_GROUP_ADDR = BASE_URL + 'bridge/admintools/nde/group/delete/:id/';

// KEPEGAWAIAN
const GET_CHOICE_UNKER = BASE_URL + 'bridge/unitkerja/option/';
const REPORT_NOMINATIF = BASE_URL + 'bridge/unitkerja/report/';
const GET_RESULT_PEGAWAI = BASE_URL + 'bridge/unitkerja/pegawai/?';
const GET_LIST_KEPEGAWAIAN_PEGAWAI_IPASN = BASE_URL + 'bridge/profile/all/'
const GET_DETAIL_KEPEGAWAIAN_PEGAWAI = BASE_URL + 'bridge/pegawai-profile/$id'

// report file
const LIST_FILE_REPORT = BASE_URL + 'crsbe/tools/export/list/';
const DOWNLOAD_FILE_REPORT = BASE_URL + 'crsbe/tools/export/download/:id/';
const CREATE_FILE_REPORT = BASE_URL + 'crsbe/tools/export/';
const DELETE_FILE_REPORT = BASE_URL + 'crsbe/tools/export/delete/:id/';

// kop surat
const GET_KOP_SURAT = BASE_URL + 'bridge/admintools/nde/operator-numbers/get-header/:id/';
const UPDATE_KOP_SURAT = BASE_URL + 'bridge/admintools/nde/operator-numbers/update-header/:id/';

// produk hukum
const PH_GET_NOMOR_OPERATOR = BASE_URL + 'digitalsign/permen/get-nomor-konseptor/?tipe_dokumen={$tipe}';
const PH_CREATE = BASE_URL + 'digitalsign/permen/submit/';
const PH_LIST = BASE_URL + 'digitalsign/permen/';
const PH_DETAIL = BASE_URL + 'digitalsign/permen/:id/';
const PH_COUNT = BASE_URL + 'digitalsign/permen/count-dashboard/';
const PH_DIRJEN_COUNT = BASE_URL + 'digitalsign/permen/count-dashboard-phDirjen/';
const PH_PARAF = BASE_URL + 'digitalsign/permen/paraf/';
const PH_GET_NOMOR = BASE_URL + 'digitalsign/permen/:id/get-nomor/?tanggal={$date}';
const PH_DIRJEN_GET_NOMOR = BASE_URL + 'digitalsign/permen-nomor/get-nomor-operator/?tipe_dokumen=$type&tanggal=$date&pemesan_nip=$nip';
const PH_UPDATE_FILE = BASE_URL + 'digitalsign/permen/:id/upload-doc/';
const PH_TTDE = BASE_URL + 'digitalsign/permen/:id/ttde/';
const PH_REVISI = BASE_URL + 'digitalsign/permen/:id/revision/';
const PH_RESUBMIT = BASE_URL + 'digitalsign/permen/:id/resubmit/';
const PH_BULKSIGN = BASE_URL + 'digitalsign/permen/bulk-ttde/';
const PH_BULK_PARAF_TTDE = BASE_URL + 'digitalsign/permen/bulk-paraf-ttde/';
const PH_REJECT = BASE_URL + 'digitalsign/permen/:id/reject/';

// new api nomor produk hukum
const PH_NEW_GET_NOMOR_OPERATOR = BASE_URL + 'digitalsign/permen-nomor/get-nomor-operator/';
const PH_GET_LIST_NOMOR_BY_USER = BASE_URL + 'digitalsign/permen-nomor/list-nomor-pemesan/?pemesan_nip={$nip}&tipe_dokumen={$tipe}';
const PH_SAVE_NOMOR_TO_DOC = BASE_URL + 'digitalsign/permen-nomor/{$id_nomor}/save-number-to-document/';
const PH_GET_LIST_NOMOR = BASE_URL + 'digitalsign/permen-nomor/';
const PH_UPDATE_NOMOR = BASE_URL + 'digitalsign/permen-nomor/{$id_nomor}/';
const PH_DELETE_NOMOR = BASE_URL + 'digitalsign/permen-nomor/{$id_nomor}/';
const CEK_HAK_PRODUK_HUKUM = BASE_URL + 'bridge/admintools/nde/produkhukum/check-akses-produk-hukum/';
const PH_CHECK_ACCESS = BASE_URL + 'crsbe/external/produkhukum/check-akses-produk-hukum/';
const PH_EXPORT_EXCEL = BASE_URL + 'digitalsign/permen/export-excel/?category={$category}';

// Program Kerja
const CRUD_LIST_PROGRAM_KERJA = BASE_URL + 'bridge/program-kerja/';
const GET_DASHBOARD_PROGRAM_KERJA = BASE_URL + 'bridge/program-kerja/dashboard/';
const ADD_ATTACHMENT_PROGRAM_KERJA = BASE_URL + 'bridge/program-kerja/attachments/';
const GET_CREATE_KOMENTAR_PROGRAM_KERJA = BASE_URL + 'bridge/program-kerja/$id/comments/'
// Program Kerja Option
const GET_ESELON_LIST = BASE_URL + 'bridge/unitkerja/option/?pusat_upt=P&max_level=2';
const GET_OPTION_PROGRAM_KERJA = BASE_URL + 'bridge/program-kerja/type/option/';
const GET_OPTION_STATUS_PROGRAM_KERJA = BASE_URL + 'bridge/program-kerja/status/option/';
const GET_OPTION_INTERVENSI_PROGRAM_KERJA = BASE_URL + 'bridge/program-kerja/intervensi/option/'

// Notification Preferences
const GET_LIST_APP_NOTIFICATION = BASE_URL + 'bridge/notif-app-list/';
const GET_BLACKLIST_NOTIFICATION = BASE_URL + 'bridge/notif-preference/';
const DELETE_ITEM_NOTIFICATION = BASE_URL + 'bridge/notif-preference/$id/';

// Operator CRS
const RESOLVE_TOKEN = BASE_URL + 'crsbe/external/profile/exchange-token/';

// Bpk Drive
const GET_COUNTER_BPK = BASE_URL + 'repository/bpk-drive-count/'
const GET_LIST_PERMINDOK = BASE_URL + 'repository/bpk-drive/folders/'
const GET_DETAIL_PERMINDOK = BASE_URL + 'repository/bpk-drive/folders/$id'
const ADD_PERMINDOK = BASE_URL + 'repository/bpk-drive/folders/'
const ADD_PERMINDOK_ATTACHMENT = BASE_URL + 'repository/bpk-drive/files/'
const EDIT_PERMINDOK = BASE_URL + 'repository/bpk-drive/folders/$id'
const DELETE_PERMINDOK_ATTACHMENT = BASE_URL + 'repository/bpk-drive/files/$id'
const DELETE_FOLDER_BPK = BASE_URL + 'repository/bpk-drive/folders/$id'
const GET_OPTION_UNKER_PERMINDOK = BASE_URL + 'bridge/admintools/nde/addressbook/para/'
const DISPOSITION_PERMINDOK = BASE_URL + 'repository/bpk-drive/folder-disposition/'
const PATCH_READ_FILE = BASE_URL + 'repository/bpk-drive/files/$id/is-read'
const DOWNLOAD_ALL_FOLDER = BASE_URL + 'repository/bpk-drive/folders/$id/download/'
const GET_LIST_PERMINDOK_MONITORING = BASE_URL + 'repository/bpk-drive/folders/shared-folders-mirror/'
const GET_DETAIL_PERMINDOK_MONITORING = BASE_URL + 'repository/bpk-drive/folders/shared-folders-mirror/$id'

const GET_LIST_KONSEP_TEMUAN = BASE_URL + 'repository/my-documents/'
const GET_LIST_KONSEP_TEMUAN_MONITORING = BASE_URL + 'repository/shared-documents/' 
const GET_DETAIL_KONSEP_TEMUAN = BASE_URL + 'repository/document-share-bpk/$id/'
const ADD_KONSEP_TEMUAN = BASE_URL + 'repository/document-share-bpk/'
const DISPOSITION_KONSEP_TEMUAN = BASE_URL + 'repository/document-forward/'
const FEEDBACK_KONSEP_TEMUAN = BASE_URL + 'repository/document-feedback/'
const ADD_KONSEP_TEMUAN_FEEDBACK_ATTACHMENT = BASE_URL + 'repository/document-feedback-attachment/'

const GET_LIST_KONSEP_TEMUAN_KKP = BASE_URL + 'repository/shared-documents/'

const GET_LIST_OPTION_BPK = BASE_URL + 'repository/list-bpk/'

export const API = {
  requestOptionsPOSTwithData,
  requestOptionsGET,
  requestOptionsPATCH,
  GET_LOGS,
  GET_LOGS_NOTIFICATION,
  GET_LOGS_SERVICE_DIGISIGN,
  requestOptionsPUT,
  requestOptionsDELETE,
  requestOptionsGETwithData,
  OO_DOC_SERVER,
  LOG_OUT_URL,
  GET_LIST_ROLE_URL,
  GET_DEPARTMENT_MASTER_DATA,
  GET_TITLE_ADMINTOOLS,
  GET_DIVISIONS_OPTIONS,
  GET_PROFILE_ADMINTOOLS,
  BASE_URL_AVATAR,
  GET_LIST_AKSI_PERUBAHAN,
  BASE_URL,
  TITLE_TREE,
  TITLE_TREE_ID,
  GET_TITLE_OPTIONS,
  GET_TEMPLATE,
  EMPLOYEES,
  POST_RESET_PASSWORD,
  GET_NOTATINDAKAN_MASTER_DATA,
  PERSONALS,
  ADD_PERSONAL,
  DELETE_PERSONAL,
  LINIMASA,
  LINIMASAPOP,
  LINIMASAACTIVEUSER,
  LIKEARTICLE,
  DISLIKEARTICLE,
  LINIMASADETAIL,
  LINIMASAADDCOMMENT,
  LINIMASAOTHERPOST,
  CHART_VIEW,
  CHART_POINT,
  CHART_COUNT,
  GET_ORGANIZATION_ADMINTOOLS,
  CHART_POST,
  PUT_INPROGRESS_DOKUMENSK_DIGISIGN,
  PROFILE_SPECIMENT,
  CHART_LIKE,
  MYPOST_LIST,
  GET_DOKUMEN_SK_PYB_PPID,
  UPDATE_MYPOST,
  GET_JOBS_ADMINTOOLS,
  UPDATE_MYPOST_DRAFT,
  GET_PENOMORAN_TREE_ADMINTOOLS,
  GET_PENOMORAN_LIST_ADMINTOOLS,
  GET_KM_PENOMORAN_ADMINTOOLS,
  GET_DIVISIONS_ADMINTOOLS,
  GET_DIVISIONS_ADMINTOOLS_DEPARTMENT,
  GET_DIVISIONS_ADMINTOOLS_DEPARTMENT_LEADER,
  GET_PENANDATANGAN_PENOMORAN_ADMINTOOLS,
  GET_PENANDATANGAN_OPERATOR,
  GET_PENANDATANGAN_SCAN,
  GET_JENIS_SURAT_ADMINTOOLS,
  GET_TYPE_SURAT_ADMINTOOLS,
  PUT_DOCUMENT_DIGISIGN_RETURN_SK,
  PUT_DOCUMENT_DIGISIGN_RETURN_PK,
  PUT_DOCUMENT_DIGISIGN_CANCEL_PK,
  POST_SET_PENOMORAN_ADMINTOOLS,
  GET_EMPLOYEE_PENOMORAN_ADMINTOOLS,
  GET_DETAIL,
  DELETE_MYPOST_ID,
  POST_MY_ARTICLE,
  POST_MY_ARTICLE_DRAFT,
  EXPORT_DOKUMEN_SK,
  ADD_ATTACHMENT,
  ADMINPENILAIAN,
  ADMINPENILAIANFILTER,
  ADMINREVIEWCOUNT,
  ADMINPENILAIANID,
  ADMINGETKATEGORI,
  ADMINGETKOMPETENSI,
  ADMINADDKOMPETENSI,
  ADMINUPDATEKOMPETENSI,
  GET_DIVISIONS_AUTOCOMPLETE_ADMINTOOLS,
  GET_FAQ,
  GET_SATKER_ADMINTOOLS,
  ADMINDELETEKOMPETENSI,
  ACTIVATE_TITLE_ADMINTOOLS,
  DEACTIVATE_TITLE_ADMINTOOLS,
  GET_DOKUMEN_COUNTER,
  ADMINADDKATEGORI,
  ADD_DOCUMENT_DIGISIGN_PK,
  ADMINUPDATEKATEGORI,
  ADMINDELETEKATEGORI,
  POST_PENOMORAN_ADMINTOOLS,
  POST_PENOMORAN_MANUAL_ADMINTOOLS,
  POST_SCAN_SURAT_MASUK,
  POST_SCAN_SURAT_KELUAR,
  GET_SCAN_SURAT_MASUK,
  GET_DOKUMEN_SK_PYB,
  GET_DOKUMEN_PK_PYB,
  GET_PENOMORAN_SCAN_SURAT,
  POST_PREVIEW_ADMINTOOLS,
  PROFILE_ID,
  PROFILE_ID_ACTIVITY,
  PROFILE_ID_ARTICLE,
  ADMINADDSCORE,
  ADMINADDSCOREALL,
  POST_EXPORT_PROFILE,
  PORTALBANNER,
  PORTALNEWS,
  PORTALGALLERY,
  GETANNOUNCEMENT,
  POSTANNOUNCEMENT,
  UPDATEANNOUNCEMENT,
  DOCUMENTS,
  SHARE_DOCUMENTS,
  ADD_DOCUMENT_ATTACHMENT,
  DELETE_DOCUMENT_ATTACHMENT,
  ADD_DOCUMENT,
  ADD_DOCUMENT_BPK,
  EDIT_DOCUMENT,
  DETAIL_DOCUMENT,
  DELETE_DOCUMENT,
  ADD_COMMENT,
  FILTER_DOCUMENT,
  FILTER_SHARE_WITH_ME,
  DOWNLOAD_ATTACHMENT,
  RATE_DOCUMENT,
  UPDATE_DOCUMENT_ATTACHMENT,
  ATTACHMENT_VIEW,
  UPDATE_STATE_DOCUMENT,
  GET_DOCUMENT_COUNTER,
  PUT_DOCUMENT_DIGISIGN_PK,
  PROFILE_MP_LOGIN,
  GET_OWN_ADMINTOOLS,
  UPDATE_SEQUENCE,
  SATKERBANNER,
  SATKERBIRTHDAY,
  SATKERPESANDIRJER,
  SATKERGALLERY,
  SATKERNEWS,
  requestOptionsPOST,
  GET_JOBS_DETAIL,
  POST_JOBS_TRIGGER_ADMINTOOLS,
  GET_JOBS_OPTION_ADMINTOOLS,
  SUMMARY_TOTAL_POST,
  SUMMARY_ACCUMULATION,
  SUMMARY_GRAPH,
  SUMMARY_REVIEW,
  EXPORT_FILE_BY_QUARTER,
  EXPORT_FILE_BY_EMPLOYEE,
  UPDATE_SPECIMENT,
  SUMMARY_BAD_USER,
  LISTVIEWEDPOST,
  LISTLIKEDPOST,
  INFOGRAFIS,
  TEKNOLOGI_TERBARU,
  GET_EMPLOYEE,
  GET_EMPLOYEE_V2,
  GET_UNIT_KERJA,
  GET_DETAIL_EMPLOYEE,
  GET_FAQ_CATEGORIES,
  GET_FAQ_GROUPS,
  GET_MOBILE_APP,
  GET_DOWNLOAD_MONITORING,
  GET_DOWNLOAD_MONITORING_V2,
  GET_LIST_PEGAWAI_URL,
  GET_FILTER_PEGAWAI_URL,
  GET_LIST_INBOX_PK,
  GET_DETAIL_PEGAWAI_URL,
  PUT_PROFILE_ME,
  GET_ROOMS,
  GET_CHAT,
  CREATE_ROOM,
  CREATE_CHAT,
  CHAT_WEB_SOCKET,
  CHAT_API,
  PORTALNEWSID,
  SATKERNEWSID,
  CREATEROLE,
  ADDMEMBERROLE,
  LISTROLE,
  DETAILROLE,
  UPDATEROLE,
  DELETEROLE,
  ACTIVATE_PROFILE_ADMINTOOLS,
  DEACTIVATE_PROFILE_ADMINTOOLS,
  IMPORTROLE,
  EXPORTROLE,
  DELETEMEMBERROLE,
  GET_LIST_COMPOSER,
  GET_LIST_REVISION,
  GET_LIST_GET_NUMBER,
  GET_SERTIFIKAT_EXTERNAL,
  GET_DETAIL_SERTIFIKAT_EXTERNAL,
  GET_LIST_COMPLETED,
  GET_LIST_DRAFT,
  GET_LIST_INPROGRESS,
  GET_LIST_READY,
  GET_DETAIL_DIGISIGN,
  UPDATE_DOKUMEN_DIGISIGN,
  EXPORT_DOKUMEN_PK,
  PUT_INPROGRESS_BANKOM_DIGISIGN,
  PUT_INPROGRESS_DOKUMENLAIN_DIGISIGN,
  ADD_ATTACHMENT_DIGISIGN,
  ADD_ATTACHMENT_SERTIFIKAT_EXTERNAL_DIGISIGN,
  ADD_DOCUMENT_DIGISIGN,
  ADD_DOCUMENT_BANKOM_DIGISIGN,
  REJECT_DOCUMENT_DIGISIGN,
  PUT_DOCUMENT_DIGISIGN,
  requestOptionsDELETEwithDATA,
  DELETEMULTIPLEROLE,
  requestOptionsPOSTFile,
  GET_TREE_TM,
  GET_LIST_TM,
  GET_DASHBOARD_TM,
  GET_KORESPONDENSI_TM,
  GET_DASHBOARD_COUNT_TM,
  GET_MONITORING_TM,
  GET_PROJECT_CHOICE_TM,
  GET_MY_TASK_COUNT_TM,
  GET_PROJECT_DETAIL_TM,
  GET_TASK_DETAIL_TM,
  GET_TASK_DETAIL_KORESPONDENSI_TM,
  GET_EXPORT_MONITORING_TM,
  ADD_CATEGORY,
  PUT_CATEGORY,
  DELETE_CATEGORY,
  ADD_FOLDER,
  ADD_LIST,
  PUT_LIST,
  DELETE_LIST,
  ADD_TASK,
  PUT_TASK,
  UPDATE_STATUS_TASK,
  UPDATE_STATUS_KORESPONDENSI,
  ADD_ATTACHMENT_TM,
  ADD_COMMENT_TM,
  DELETE_TASK_TM,
  EVENTCREATE,
  EVENT,
  EVENTTODAY,
  EVENTID,
  EVENTUPDATE,
  EVENTUPDATESTATUS,
  GET_LIST_APPROVAL_SK,
  GET_LIST_NEED_SIGN_SK,
  GET_PERIZINAN_ESEA_COUNT,
  EVENTDELETE,
  AGENDACREATE,
  AGENDA,
  AGENDAID,
  AGENDAUPDATE,
  AGENDADELETE,
  NOTULENSICREATE,
  NOTULENSI,
  NOTULENSIID,
  NOTULENSIUPDATE,
  NOTULENSIDELETE,
  PRESENSI,
  PRESENSIID,
  GET_KM_MASTER_DATA,
  PRESENSIUPDATE,
  PRESENSIDELETE,
  ATTACHMENTCREATE,
  TITLE_SPECIMENT,
  TASKCREATE,
  TASK,
  TASKID,
  TASKUPDATE,
  TASKDELETE,
  POST_AKSI_PERUBAHAN,
  APPROVER,
  EVENTLISTPROGRESS,
  NOTULENSIAPPROVE,
  NOTULENSIREADYTOAPPROVE,
  GET_LIST_GRUP_KALENDER,
  GET_LIST_ACARA,
  GET_PIC_ACARA,
  CREATE_ACARA,
  CREATE_GRUP_KALENDER,
  GET_DETAIL_ACARA,
  GET_DETAIL_GRUP,
  UPDATE_GRUP_KALENDER,
  UPDATE_EVENT_KALENDER,
  DELETE_GRUP_KALENDER,
  DELETE_EVENT_KALENDER,
  GET_LIST_ACARA_EVENT,
  GET_DETAIL_ACARA_EVENT,
  GET_LIST_SUBAGENDA_EVENT_KALENDER,
  GET_LIST_ACARA_PERSONAL,
  GET_DETAIL_ACARA_PERSONAL,
  GET_TOKEN_CRSFE_KALENDER,
  COMMENTADDEM,
  AGENDAUPDATESTATE,
  ADMINPENILAIANCANCEL,
  ADMINPENILAIANTAKEDOWN,
  ADMINPENILAIANKOMENTAR,
  EVENTCHOISECALENDER,
  AGENDANOTIFICATION,
  EVENTNOTIFICATION,
  GET_LIST_COURSE_DIGISIGN,
  GET_DETAIL_COURSE_DIGISIGN,
  GET_PENERIMA_SERTIF_BY_COURSE,
  GET_LIST_REJECTED_DIGISIGN,
  GET_LIST_REVISI_DIGISIGN,
  GET_LIST_REJECTED_PERIZINAN_DIGISIGN,
  GET_LIST_SIGNED_DIGISIGN,
  GET_LIST_RETRY_DIGISIGN,
  GET_SUMMARY_COUNT,
  GET_SUMMARY_LIST,
  GET_SUBJECT_LIST,
  GET_EXPORT_SUMMARY_LIST,
  GET_TEMPLATE_DIGISIGN,
  CHECK_PDF_DIGISIGN,
  POST_TRIGGER_DIGISIGN,
  GET_COUNTER_DIGISIGN,
  ADD_CSV_TO_JSON_DIGISIGN,
  GET_LIST_COMPOSER_SM,
  GET_LIST_INPROGRESS_SM,
  GET_LIST_READY_SM,
  GET_LIST_COMPLETED_SM,
  PUT_INPROGRESS_SM_DIGISIGN,
  POST_OVERRIDE_USER_DIGISIGN,
  UPDATE_EVALUASI_DIGISIGN,
  PARAF_DIGISIGN,
  PENOMORAN_DIGISIGN,
  REJECT_PERIZINAN_DIGISIGN,
  GET_LIST_TRACK_DIGISIGN,
  GET_PERIZINAN_PKRL_COUNT,
  PARAF_BEFORE_TTDE_DIGISIGN,
  GET_LIST_LAPORAN_PKRL,
  DOWNLOAD_DASHBOARD_LAPORAN_PKRL,
  DOWNLOAD_LAPORAN_PKRL,
  DELETE_DOCUMENT_DIGISIGN,
  GET_MONITORING_LIST_DIGISIGN,
  GET_MONITORING_DASHBOARD_DIGISIGN,
  GET_SIAPMUTU_COUNT,
  GET_TEMPLATE_RECEIVERS_BANKOM,
  GET_DETAIL_PEGAWAI_SIPEG,
  GETKATEGORI,
  GETKOMPETENSI,
  GETSATKERBYUNKER,
  GETUNKER,
  SPESIMENID_TITLE,
  SPESIMENID_EMPLOYEE,
  LISTSERVICEROLE,
  UPDATE_REF_NUMBER,
  ADD_SURVEY,
  GET_SURVEY_REPORT,
  GET_SURVEY_COUNT,
  GET_SURVEY_DETAIL,
  GET_SURVEY_EXPORT,
  UPLOAD_DRAFT,
  EXPORT_SCAN_IN,
  EXPORT_SCAN_OUT,
  EXPORT_PENOMORAN,
  GET_LIST_PRESENSI,
  GET_LAST_LOG,
  ADD_GROUP_ADDR,
  DETAIL_GROUP_ADDR,
  LIST_GROUP_ADDR,
  EDIT_GROUP_ADDR,
  DELETE_GROUP_ADDR,
  GET_CHOICE_UNKER,
  REPORT_NOMINATIF,
  GET_RESULT_PEGAWAI,
  GET_LIST_KEPEGAWAIAN_PEGAWAI_IPASN,
  GET_DETAIL_KEPEGAWAIAN_PEGAWAI,
  POST_ATTACHMENTS,
  ADD_ATTACHMENT_NEW,
  LIST_FILE_REPORT,
  CREATE_FILE_REPORT,
  DELETE_FILE_REPORT,
  DOWNLOAD_FILE_REPORT,
  GET_KOP_SURAT,
  UPDATE_KOP_SURAT,
  PH_CREATE,
  PH_LIST,
  PH_DETAIL,
  PH_COUNT,
  PH_DIRJEN_COUNT,
  PH_PARAF,
  PH_GET_NOMOR,
  PH_DIRJEN_GET_NOMOR,
  PH_UPDATE_FILE,
  PH_TTDE,
  PH_REVISI,
  PH_REJECT,
  PH_GET_NOMOR_OPERATOR,
  PH_RESUBMIT,
  PH_NEW_GET_NOMOR_OPERATOR,
  PH_GET_LIST_NOMOR_BY_USER,
  PH_SAVE_NOMOR_TO_DOC,
  PH_GET_LIST_NOMOR,
  PH_UPDATE_NOMOR,
  PH_DELETE_NOMOR,
  CEK_HAK_PRODUK_HUKUM,
  PH_CHECK_ACCESS,
  PH_EXPORT_EXCEL,
  GET_LIST_DOKUMEN_LPMUKP,
  GET_DETAIl_DOKUMEN_LPMUKP,
  GET_NOTIFICATIONS,
  READ_NOTIFICATIONS,
  GET_COUNT_NOTIFICATIONS,
  GET_DASHBOARD_COUNT_DOKUMEN,
  PH_BULKSIGN,
  GET_NOTULENSI,
  GET_SHARED_NOTULENSI,
  UPDATE_NOTULENSI,
  PH_BULK_PARAF_TTDE,
  CRUD_LIST_PROGRAM_KERJA,
  ADD_ATTACHMENT_PROGRAM_KERJA,
  GET_DASHBOARD_PROGRAM_KERJA,
  GET_OPTION_PROGRAM_KERJA,
  GET_OPTION_STATUS_PROGRAM_KERJA,
  GET_OPTION_INTERVENSI_PROGRAM_KERJA,
  GET_ESELON_LIST,
  GET_CREATE_KOMENTAR_PROGRAM_KERJA,
  GET_BLACKLIST_NOTIFICATION,
  DELETE_ITEM_NOTIFICATION,
  GET_LIST_APP_NOTIFICATION,
  RESOLVE_TOKEN,
  GET_COUNTER_BPK,
  GET_LIST_PERMINDOK,
  GET_DETAIL_PERMINDOK,
  ADD_PERMINDOK,
  ADD_PERMINDOK_ATTACHMENT,
  EDIT_PERMINDOK,
  DELETE_PERMINDOK_ATTACHMENT,
  GET_LIST_KONSEP_TEMUAN,
  GET_LIST_KONSEP_TEMUAN_MONITORING,
  GET_DETAIL_KONSEP_TEMUAN,
  ADD_KONSEP_TEMUAN,
  DISPOSITION_KONSEP_TEMUAN,
  FEEDBACK_KONSEP_TEMUAN,
  ADD_KONSEP_TEMUAN_FEEDBACK_ATTACHMENT,
  GET_LIST_KONSEP_TEMUAN_KKP,
  GET_LIST_OPTION_BPK,
  DELETE_FOLDER_BPK,
  GET_OPTION_UNKER_PERMINDOK,
  DISPOSITION_PERMINDOK,
  PATCH_READ_FILE,
  DOWNLOAD_ALL_FOLDER,
  GET_LIST_PERMINDOK_MONITORING,
  GET_DETAIL_PERMINDOK_MONITORING
};

export const COLORS = {
  primary: '#800000',
  secondary: 'rgba(128, 0, 0, 0.1)',
  hover: '#6b0101',
  white: '#FFFFFF',
  black: '#000000'
}
